import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client } from './client.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

    constructor(private _httpClient: HttpClient) { }


    getClient(id: number): Observable<Client> {
        return this._httpClient.get<Client>('/ypm/api/fm/client/' + id);
    }

    saveClient(client: Client): Observable<Client> {
        return this._httpClient.post<Client>('/ypm/api/fm/client' , client);
    }

    deleteClient(client: Client): Observable<Client> {
        return this._httpClient.delete<Client>('/ypm/api/fm/client/' + client.id);
    }

    checkProjectsForClient(client: Client): Observable<any> {
        return this._httpClient.get<any>('/ypm/api/fm/canDeleteClient/' + client.id);
    }
}
